import { ICellRendererParams } from "ag-grid-community";
import { useTranslation } from "react-i18next";
import { IBooking } from "../../../../../types";

const CellStatus = (params: ICellRendererParams<IBooking>) => {

    const b = params.data as IBooking;
    const { t } = useTranslation('booking');

    return (
        <>
            {t(`status.${b.status}`)}
            {b.subStatus && ' - ' +  t(`substatus.${b.subStatus}`)}
        </>

    );
};

export default CellStatus;
